// =============================================================================
// 공개 페이지 template 컴포넌트 init 오케스트레이션 — app.ts(app.js) 흐름에 통합.
//   · 갤러리 런타임(TemplateController)은 포함하지 않는다(그건 template-app.ts → /templates 전용).
//   · 각 컴포넌트 index.js 는 import 시 DOMContentLoaded 에 self-register 하므로 eager glob import 만으로 초기화된다.
//     (루트 셀렉터가 없으면 no-op, window.Swiper/gsap 부재 시 early-return — 컴포넌트 미사용 페이지에서도 안전.)
//   · vendor(Swiper/GSAP/AOS/jQuery/ScrollTrigger)는 config/site/lighthouse.php 가 공개 페이지에 이미 전역 로드.
// CSS(template.css / template-components.css)는 이번 단계에서 style.css 로 병합하지 않고 분리 유지(토큰 충돌).
// =============================================================================

import.meta.glob('../../views/template/components/**/index.js', { eager: true });

/**
 * initTemplateComponents() : app.ts 에서 호출하는 훅.
 * 컴포넌트는 위 glob import 시점에 self-register 하므로 최초 init 은 자동.
 * 이 함수는 (SPA/동적 삽입 대비) 'template:components-init' 이벤트를 디스패치해 재초기화를 트리거한다.
 */
export function initTemplateComponents(): void {
    if (typeof document !== 'undefined' && document.readyState !== 'loading') {
        window.dispatchEvent(new Event('template:components-init'));
    }
}
